import { useParams } from "react-router-dom"
import { compose, withProps } from "recompose"
import { graphql } from "@apollo/client/react/hoc"
import gql from "graphql-tag"
import moment from "moment"
import EmployeeCaseUserVisitList from "."

const EmployeeCaseUserVisitListEnhanced = compose(
  withProps(() => {
    const { facilityId, caseId } = useParams()
    return {
      facilityId,
      caseId,
    }
  }),
  graphql(
    gql`
      query ContactTracingCaseDetail($facilityId: ID!, $caseId: ID!) {
        facility(id: $facilityId) {
          id
          contactTracingCases(ids: [$caseId]) {
            id
            subjects {
              entity {
                ... on User {
                  id
                  name
                  employeeId
                  healthcareRole
                  department {
                    id
                    name
                  }
                  compliance {
                    timeslices {
                      full {
                        aggregates {
                          overall {
                            compliancePercentage
                            totalOpportunitiesCount
                          }
                        }
                      }
                    }
                  }
                  contactTracingVisits {
                    edges {
                      node {
                        id
                        location {
                          id
                          name
                        }
                        unit {
                          id
                          name
                        }
                        duration
                        entryAt
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `,
    {
      options: ({ facilityId, caseId }) => ({
        variables: { facilityId, caseId },
      }),
      props: ({ data: { error, loading, facility } }) => {
        if (error) throw error

        if (loading) return { loading }

        if (facility.contactTracingCases.length === 0) throw Error("404")

        const subject = facility.contactTracingCases[0].subjects[0]

        return {
          compliance:
            subject.entity.compliance.timeslices.full.aggregates.overall
              .compliancePercentage,
          department: subject.entity.department.name,
          employeeId: subject.entity.employeeId,
          name: subject.entity.name,
          role: subject.entity.healthcareRole,
          visits: subject.entity.contactTracingVisits.edges.map((edge) => ({
            location: edge.node.location.name,
            unit: edge.node.unit.name,
            entryAt: moment.parseZone(edge.node.entryAt),
            duration: edge.node.duration,
          })),
        }
      },
    }
  )
)(EmployeeCaseUserVisitList)

export default EmployeeCaseUserVisitListEnhanced
